import { Injectable, NgZone } from '@angular/core';
declare var $: any;

@Injectable({
  providedIn: 'root',
})
export class ScriptLoaderService {
  constructor(public ngZone: NgZone) {}

  public href: any;

  initializeApp(): Promise<void> {
    var _self = this;
    return new Promise((resolve, reject) => {
      console.log('AppInitService: Initialize application...');

      _self.cleanupJQueryFunctions();
      // Simulating async operation (like an HTTP call)
      setTimeout(() => {
        console.log('AppInitService: Initialization complete.');
        resolve();
      }, 2000);
    });
  }
  private scripts: any = {};
  load(...scripts: string[]) {
    this.scripts = scripts;
    let promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      let script = document.createElement('script') as any;
      script.type = 'text/javascript';
      script.src = name;

      if (script.readyState) {
        //IE
        script.onreadystatechange = () => {
          if (
            script.readyState === 'loaded' ||
            script.readyState === 'complete'
          ) {
            script.onreadystatechange = null;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          }
        };
      } else {
        //Others
        script.onload = () => {
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
      }

      script.onerror = (error: any) =>
        resolve({ script: name, loaded: false, status: 'Loaded' });
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }

  initializeJQueryFunctions() {
    console.log('initializeJQueryFunctions');
    this.cleanupJQueryFunctions();

    $('.toggle-icon').on('click', function () {
      const $wrapper = $('.wrapper');
      const $sidebarWrapper = $('.sidebar-wrapper');
      if ($wrapper.hasClass('toggled')) {
        $wrapper.removeClass('toggled');
        $sidebarWrapper.off('hover');
      } else {
        $wrapper.addClass('toggled');
        $sidebarWrapper.hover(
          function () {
            $wrapper.addClass('sidebar-hovered');
          },
          function () {
            $wrapper.removeClass('sidebar-hovered');
          }
        );
      }
    });

    $('.mobile-search-icon').on('click', function () {
      $('.search-bar').addClass('full-search-bar');
    });

    $('.search-close').on('click', function () {
      $('.search-bar').removeClass('full-search-bar');
    });

    $('.mobile-toggle-menu').on('click', function () {
      $('.wrapper').addClass('toggled');
    });

    $('.dark-mode').on('click', function () {
      const $darkModeIcon = $('.dark-mode-icon i');
      if ($darkModeIcon.attr('class') == 'bx bx-sun') {
        $darkModeIcon.attr('class', 'bx bx-moon');
        $('html').attr('class', 'light-theme');
      } else {
        $darkModeIcon.attr('class', 'bx bx-sun');
        $('html').attr('class', 'dark-theme');
      }
    });

    this.ngZone.runOutsideAngular(() => {
      $(window).on(
        'scroll',
        this.debounce(() => {
          $(window).scrollTop() > 300
            ? $('.back-to-top').fadeIn()
            : $('.back-to-top').fadeOut();
        }, 500)
      );
    });

    $('.back-to-top').on('click', function () {
      $('html, body').animate({ scrollTop: 0 }, 600);
      return false;
    });

    $('.chat-toggle-btn').on('click', function () {
      $('.chat-wrapper').toggleClass('chat-toggled');
    });

    $('.chat-toggle-btn-mobile').on('click', function () {
      $('.chat-wrapper').removeClass('chat-toggled');
    });

    $('.switcher-btn').on('click', function () {
      $('.switcher-wrapper').toggleClass('switcher-toggled');
    });

    $('.close-switcher').on('click', function () {
      $('.switcher-wrapper').removeClass('switcher-toggled');
    });

    $('#lightmode').on('click', function () {
      $('html').attr('class', 'light-theme');
    });

    $('#darkmode').on('click', function () {
      $('html').attr('class', 'dark-theme');
    });

    $('#semidark').on('click', function () {
      $('html').attr('class', 'semi-dark');
    });

    $('#minimaltheme').on('click', function () {
      $('html').attr('class', 'minimal-theme');
    });

    $('#headercolor1').on('click', function () {
      $('html')
        .addClass('color-header headercolor1')
        .removeClass(
          'headercolor2 headercolor3 headercolor4 headercolor5 headercolor6 headercolor7 headercolor8'
        );
    });

    $('#headercolor2').on('click', function () {
      $('html')
        .addClass('color-header headercolor2')
        .removeClass(
          'headercolor1 headercolor3 headercolor4 headercolor5 headercolor6 headercolor7 headercolor8'
        );
    });

    $('#headercolor3').on('click', function () {
      $('html')
        .addClass('color-header headercolor3')
        .removeClass(
          'headercolor1 headercolor2 headercolor4 headercolor5 headercolor6 headercolor7 headercolor8'
        );
    });

    $('#headercolor4').on('click', function () {
      $('html')
        .addClass('color-header headercolor4')
        .removeClass(
          'headercolor1 headercolor2 headercolor3 headercolor5 headercolor6 headercolor7 headercolor8'
        );
    });

    $('#headercolor5').on('click', function () {
      $('html')
        .addClass('color-header headercolor5')
        .removeClass(
          'headercolor1 headercolor2 headercolor4 headercolor3 headercolor6 headercolor7 headercolor8'
        );
    });

    $('#headercolor6').on('click', function () {
      $('html')
        .addClass('color-header headercolor6')
        .removeClass(
          'headercolor1 headercolor2 headercolor4 headercolor5 headercolor3 headercolor7 headercolor8'
        );
    });

    $('#headercolor7').on('click', function () {
      $('html')
        .addClass('color-header headercolor7')
        .removeClass(
          'headercolor1 headercolor2 headercolor4 headercolor5 headercolor6 headercolor8'
        );
    });

    $('#headercolor8').on('click', function () {
      $('html')
        .addClass('color-header headercolor8')
        .removeClass(
          'headercolor1 headercolor2 headercolor3 headercolor5 headercolor6 headercolor7'
        );
    });

    $('#sidebarcolor1').on('click', function () {
      $('html').attr('class', 'color-sidebar sidebarcolor1');
    });

    $('#sidebarcolor2').on('click', function () {
      $('html').attr('class', 'color-sidebar sidebarcolor2');
    });

    $('#sidebarcolor3').on('click', function () {
      $('html').attr('class', 'color-sidebar sidebarcolor3');
    });

    $('#sidebarcolor4').on('click', function () {
      $('html').attr('class', 'color-sidebar sidebarcolor4');
    });

    $('#sidebarcolor5').on('click', function () {
      $('html').attr('class', 'color-sidebar sidebarcolor5');
    });

    $('#sidebarcolor6').on('click', function () {
      $('html').attr('class', 'color-sidebar sidebarcolor6');
    });

    $('#sidebarcolor7').on('click', function () {
      $('html').attr('class', 'color-sidebar sidebarcolor7');
    });

    $('#sidebarcolor8').on('click', function () {
      $('html').attr('class', 'color-sidebar sidebarcolor8');
    });
  }

  cleanupJQueryFunctions() {
    $('.toggle-icon').off('click');
    $('.mobile-search-icon').off('click');
    $('.search-close').off('click');
    $('.mobile-toggle-menu').off('click');
    $('.dark-mode').off('click');
    $(window).off('scroll');
    $('.back-to-top').off('click');
    $('.chat-toggle-btn').off('click');
    $('.chat-toggle-btn-mobile').off('click');
    $('.switcher-btn').off('click');
    $('.close-switcher').off('click');
    $('#lightmode').off('click');
    $('#darkmode').off('click');
    $('#semidark').off('click');
    $('#minimaltheme').off('click');
    $('#headercolor1').off('click');
    $('#headercolor2').off('click');
    $('#headercolor3').off('click');
    $('#headercolor4').off('click');
    $('#headercolor5').off('click');
    $('#headercolor6').off('click');
    $('#headercolor7').off('click');
    $('#headercolor8').off('click');
    $('#sidebarcolor1').off('click');
    $('#sidebarcolor2').off('click');
    $('#sidebarcolor3').off('click');
    $('#sidebarcolor4').off('click');
    $('#sidebarcolor5').off('click');
    $('#sidebarcolor6').off('click');
    $('#sidebarcolor7').off('click');
    $('#sidebarcolor8').off('click');
  }

  debounce(func: Function, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}